import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ExerciseTemplateDto } from '@therapist/shared/models/exercise/exercise-template.dto';

@Injectable({ providedIn: 'root' })
export class ExerciseTemplateApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/exercise-template`;
  }

  getAll(): Observable<ExerciseTemplateDto[]> {
    return this.#http.get<ExerciseTemplateDto[]>(`${this.endpoint}`);
  }

  getByJointIds(jointIds: string[]): Observable<ExerciseTemplateDto[]> {
    const params = jointIds.map(id => `jointIds=${id}`).join('&');
    return this.#http.get<ExerciseTemplateDto[]>(`${this.endpoint}/by-joints?${params}`);
  }
}
